export default __webpack_public_path__ + "static/media/fab-background_11zon.9c979982.png";